import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import heroBgDesktop from "../../img/Markets/banner-bg.webp";
import heroBgMobile from "../../img/Markets/banner-bg-mobile.webp";
import heroProduct from "../../img/Markets/banner-product.webp";
import Fade from 'react-reveal/Fade';

function Banner() {
  const { link } = useContext(LinkContext);
  const { t, i18n } = useTranslation();
  const isPL = i18n.language === "pl";

  return (
    <section>
      {/* Desktop */}
      <div className="hidden xl:block pt-[122px]">
        <div className={`relative mx-auto max-w-[1220px] overflow-hidden ${isPL ? "h-[640px]" : "h-[520px]"}`}>
          <img src={heroBgDesktop} alt="" className="absolute inset-0 h-full w-full object-cover" />

          <Fade bottom>
          <div className="absolute left-[45px] top-[50px] w-[471px]">
            <h1 className="font-['Nunito_Sans'] text-[48px] font-black leading-[1.5] text-[#3273b4]">
              {t("markets.banner.title")}
            </h1>
            <span className="mt-[2px] block h-[4px] w-[193px] bg-[#05193a]" />
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.banner.subtitle")}
            </p>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.banner.text1")}
            </p>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.banner.text2")}
            </p>
            <a
              href={link}
              className="mt-[20px] inline-flex h-[42px] items-center justify-center rounded-[10px] bg-[#05193a] px-[35px] font-[Inter] text-[16px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>

          </Fade>

          <Fade bottom delay={200}>
          <div className="absolute right-[100px] top-[72px] h-[395px] w-[491px] overflow-hidden">
            <img src={heroProduct} alt="" className="h-full w-full object-contain" />
          </div>
          </Fade>
        </div>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        <div className="relative h-[518px] overflow-hidden mt-[60px] pt-[111px]">
          <img src={heroBgMobile} alt="" className="absolute inset-0 h-full w-full object-cover" />

          <div className="absolute top-[40px] inset-x-0 flex flex-col items-center text-center px-[20px]">
            <h1 className="font-['Nunito_Sans'] text-[34px] font-black leading-[1.2] text-[#3273b4]">
              {t("markets.banner.title")}
            </h1>
            <p className="mt-[12px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.banner.subtitle")}
            </p>
          </div>

          <div className="absolute top-[130px] left-1/2 -translate-x-1/2">
            <a
              href={link}
              className="inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>

          <div className="absolute bottom-[-20px] left-1/2 -translate-x-1/2 h-[229px] w-[337px] overflow-hidden">
            <img src={heroProduct} alt="" className="h-full w-full object-contain" />
          </div>
        </div>

        <Fade bottom>
        <div className="px-[20px] mt-[30px]">
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("markets.banner.text1")}
          </p>
          <p className="mt-[14px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("markets.banner.text2")}
          </p>
          <a
            href={link}
            className="mt-[30px] inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
          >
            {t("header.openAccount")}
          </a>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default Banner;
